(function () {
  const $videos = document.querySelectorAll('section.video_loop video');

  if ($videos.length) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {

        if (isIntersecting && target.paused) {
          console.log('Video ', target, ' should play');
          target.play();
        } else if (!isIntersecting && !target.paused) {
          console.log('Video ', target, ' should pause');
          target.pause();
        }
      });
    }, {});

    $videos
      .forEach($video => {
        observer.observe($video);
      });
  }
})();